import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { LinkButtons } from '../FieldComponets/LinkButtons';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate } from '../../utils/Helper';
import { AtributelistGetAction  , AtributeStatusChangesAction  } from '../../Redux/Action/AtributeAction';
import { FormattedMessage, useIntl } from 'react-intl';

function AttribsManagementList() {

  const dispatch = useDispatch<any>();
  const intl = useIntl();

  const atributedata = useSelector((state: any) => state.AtributeGetState);
  const atributestatus = useSelector((state:any)=>state.AtributeStatusState)

  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(['ASC']);
  const formRef = useRef<HTMLFormElement>(null);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('1');
  const [rowCount, setRowCount] = useState(0);
  const [serachstatus, setSerachstatus] = useState<any>('')



  const handleStatusChange = (id:any)=>{
   const data ={
    status_id : id?.id,
    status:id.status == 1 ? 0 :1
   }
 dispatch(AtributeStatusChangesAction(data))
  }
  // Table Coulmns
  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: intl.formatMessage({ id: "s_no" }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50
    },
    {
      accessorKey: 'title',
      header: intl.formatMessage({ id: "title" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'attrib_type',
      header: intl.formatMessage({ id: "attribute_type" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      header: intl.formatMessage({ id: "status" }),
      size: 50,
      accessorFn: (row: { id: any, status: number }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <label className="switch">
              <input type="checkbox" checked={row.status == 1}  onChange={(e)=>handleStatusChange(row)} />
              <span className="slider round"></span>
            </label>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: intl.formatMessage({ id: "created_at" }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'updated_at',
      header: intl.formatMessage({ id: "last_update_on" }),
      accessorFn: (row: { updated_at: any; }) => getDate(row.updated_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "action" }),
      size: 50,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`atribute-edit`}
                pageID={row?.id}
                showEdit={true}
                showView={false}
                showDelete={false}
              />
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );
        query.columnFilters.push({ id: "attrib_type", value: "1" })
        await dispatch(AtributelistGetAction(query));
        await dispatch(AtributeStatusChangesAction("RESET"))

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    atributestatus.status,
  ]);
  useEffect(() => {
    setData(atributedata?.data?.data?.rows);
    setRowCount(atributedata?.data?.data?.count);
  }, [atributedata?.data]);
  const resetSearchfilter = () => {
   
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" }
    ]
    setColumnFilters(columnFilters)

  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      // { id: "start_date", value: startDate.trim() },
      // { id: "end_date", value: endDate.trim() },
      { id: "search", value: serachstatus?.searchname?.trim() },
       { id: "user_type", value: serachstatus?.user_type},
    ]
    setColumnFilters(columnFilters)
  }

  return (
    <Fragment>
      {(loading || atributedata?.loading) ? <Spinner /> : ""}

      <PageLayout
        title={<FormattedMessage id="block_reason_management" />}
        breadcrumbs={{
          secLast: { 'link': '/atribute-list', 'name': <FormattedMessage id="block_reason_management" /> },
        }}
        buttons={[
          { url: '/atribute-add', className: 'btn btn-success', text: intl.formatMessage({ id: "add_new_block_reason" }), show: true }, // This button will be shown
        ]}
      >
       {/* <form ref={formRef} onSubmit={handleserach}>
          <div className="row gy-3">
            <div className='col-md-6 col-lg-4 col-xl-3'>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" name='searchname' className="form-control m-0" placeholder='Search by name' onChange={handleFilterValue} />
                </div>
                
              </div>
              
            </div>
            <div className='row gy-3 mt-3 mb-4'>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>All user type</label>
              <select className='form-select shadow-none' name="user_type" id="cars" onChange={handleFilterValue}>
                <option value="">All</option>
                <option value="Customer">Customer</option>
                <option value="Salon">Salon</option>
              </select>
            </div>
          </div>
            <div className="col-6">
              <button className='btn theme-bg text-white me-2'>Filter</button>
              <button className='btn btn-success' onClick={() => resetSearchfilter()} >Reset</button>
            </div>
          </div>
         
        </form> */}
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: "error_loading_data" }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: "search_from_name" }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }

      </PageLayout>
    
    </Fragment>

  )
}

export default AttribsManagementList